<template>
    <div class="row">
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Journal System</h5>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <div class="form-inline ml-auto">
                  <div class="button-group">
                      <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addProject">
                        <i class="fa fa-plus" aria-hidden="true"></i> New
                      </button>
                      <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                        <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                      </button>
                      <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-filter" aria-hidden="true"></i>
                          Filter
                          <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu p-2" >
                        <span>Etc</span>
                        <div class="dropdown-divider"></div>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" value="true" v-model="filterNotBalance"/>&nbsp;  Not Balance (D/K)</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" value="true" v-model="filterDiffDate"/>&nbsp;  Diff Date Ref</a></li>
                      </ul>
                      rows:
                      <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                        <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                      </select>
                      <span class="mr-1">
                        Total rows: <b>{{ filterData.length }}</b>
                      </span>
                      <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                  </div>
                  <div class="form-group mx-sm-3 mb-2">
                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                  </div>
                  <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                  <nav aria-label="Page navigation example" class="pull-right">
                      <ul class="pagination">
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                              </a>
                          </li>
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </a>
                          </li>
                      </ul>
                  </nav>
                </div>
                <table class="table table-item mb-0 table-sm table-striped">
                    <thead>
                        <tr>
                            <th>
                              <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll" @click="select">
                                <i class="form-icon"></i>
                              </label>
                            </th>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                                {{ t.name }}
                                <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="10" style="text-align: center;"><i>No Data</i></td>
                      </tr>
                      <tr v-for="u in filterData" v-bind:key="u.id">
                        <td>
                          <label class="form-checkbox">
                            <input type="checkbox" :value="u.id" v-model="selected">
                            <i class="form-icon"></i>
                          </label>
                        </td>
                        <td>
                          <span class="badge badge-primary" v-if="u.status === 'posted'">{{ u.status }}</span>
                          <span class="badge badge-warning" v-else>{{ u.status }}</span>
                        </td>
                        <td @click="editJournal(u.id)" style="cursor: pointer;"><b>{{ u.journal_code }}</b></td>
                        <td>
                          <span class="badge badge-success" v-if="u.type_id === 'RV'">{{ u.type_id }}</span>
                          <span class="badge badge-info" v-else>{{ u.type_id }}</span>
                        </td>
                        <td>{{ u.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td>{{ u.journal_description }}</td>
                        <td>{{ u.ref_no }}</td>
                        <td>{{ u.ref_type }}</td>
                        <td>{{ u.ref_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td class="text-right">
                          <span class="badge badge-danger" v-if="u.debit !== u.credit">{{ u.debit }}</span>
                          <span v-else>{{ u.debit | currency }}</span>
                        </td>
                        <td class="text-right">
                          <span class="badge badge-danger" v-if="u.debit !== u.credit">{{ u.credit }}</span>
                          <span v-else>{{ u.credit | currency }}</span>
                        </td>
                        <td>
                            <span v-if="u.auto === true"><i class="fa fa-check" style="color: green"></i></span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="text-right">{{ totalDebit | currency }}</td>
                        <td class="text-right">{{ totalCredit | currency }}</td>
                      </tr>
                    </tfoot>
                </table>
              </div>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import { getHeader, journalUrl } from '../../config'

export default {
  name: 'JournalSystemList',
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      filterDiffDate: false,
      filterNotBalance: false,
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status',
        align: 'text-left'
      }, {
        name: 'Journal',
        prop: 'journal_code',
        align: 'text-left'
      }, {
        name: 'Type',
        prop: 'type_id',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'journal_date',
        align: 'text-left'
      }, {
        name: 'Description',
        prop: 'journal_description',
        align: 'text-left'
      }, {
        name: 'Ref No',
        prop: 'ref_no',
        align: 'text-left'
      }, {
        name: 'Ref Type',
        prop: 'ref_type',
        align: 'text-left'
      }, {
        name: 'Ref Date',
        prop: 'ref_date',
        align: 'text-left'
      }, {
        name: 'Debit',
        prop: 'debit',
        align: 'text-right'
      }, {
        name: 'Credit',
        prop: 'credit',
        align: 'text-right'
      }, {
        name: 'Auto',
        prop: 'auto',
        align: 'text-left'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable
    }),
    totalDebit () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].debit)
      }
      return sum
    },
    totalCredit () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].credit)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      var col = this.sortColumn
      var ascending = this.ascending
      return this.dataRaw.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterNotBalance === true) {
          if (Math.round(parseFloat(d.debit)) !== Math.round(parseFloat(d.credit))) {
            console.log('Not Balance: ' + Math.round(parseFloat(d.debit)) + ' >< ' + Math.round(parseFloat(d.credit)))
            return d
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterDiffDate === true) {
          var refDate = d.ref_date
          var journalDate = d.journal_date
          if (journalDate !== refDate) {
            return d
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editJournal (id) {
      axios.get(journalUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.$emit('editJournal', response.data.data)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!!',
            error.response.data.message,
            'error'
          )
        })
    },
    addProject () {
      this.$emit('newJournal', true)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = journalUrl + '?begin=' + begin + '&end=' + end + '&auto=true'
      axios.get(url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.currentPage = 1
          this.searchQuery = ''
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            'Cannot Get Sale Order Index',
            'error'
          )
        })
    }
  }
}
</script>
